import { render, staticRenderFns } from "./AlterarPedidoDeCompraModal.vue?vue&type=template&id=dae9b9d0&scoped=true"
import script from "./AlterarPedidoDeCompraModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AlterarPedidoDeCompraModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AlterarPedidoDeCompraModal.vue?vue&type=style&index=0&id=dae9b9d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dae9b9d0",
  null
  
)

export default component.exports